import ActiveMembers from '../molecules/activeMembers'
import Announcements from '../molecules/announcements'
import { useEffect, useReducer } from 'react'

const reducerAnnouncements = (state,action) => {
  switch (action.type) {
    case "INITIAL":
      return action.announcements
    default:
      return state
  }
}

const reducerMembers = (state, action) => {
  switch(action.type){
    case "INITIAL":
      return action.members
    case "UPDATE":
      return action.members
    default:
      return state
  }
}

const SideBar = ({ socket }) => {
  const [announcements, dispatchAnnouncements] = useReducer(reducerAnnouncements,[]);
  const [members, dispatchMembers] = useReducer(reducerMembers,[]);
  
  useEffect(() => {
    if(socket.nsp === "null") return null;
    socket.on('data', (data) => {
    if(data.announcements){
      dispatchAnnouncements({type: "INITIAL", announcements: data.announcements});
    }
    if(data.members){
      dispatchMembers({type: "INITIAL", members: data.members});
    }
  });
  
  socket.on('members',(data) => {
      dispatchMembers({type: "UPDATE", members: data});
    })

  }, [socket])

  return (
    <div id="sideBar" className="hidden flex-none w-80 bg-[#F4F9F9] h-screen px-8 py-6 pt-20 sticky top-0 z-0 overflow-y-auto no-scrollbar md:block">
      <Announcements announcements={announcements} />
      <ActiveMembers members={members}/>
    </div>
  )
}

export default SideBar
